export const RedInfo = ({ children, className = '' }) => {
  return (
    <div className={`red-info ${className}`}>
      <div className="red-info__icon">
        <svg
          width="32"
          height="32"
          viewBox="0 0 32 32"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <rect
            x="1"
            y="1"
            width="30"
            height="30"
            rx="15"
            stroke="#FF337C"
            strokeWidth="2"
          />
          <path
            d="M17.188 10.128L16.852 17.952H14.532L14.196 10.128H17.188ZM17.124 19.264V22H14.276V19.264H17.124Z"
            fill="#FF337C"
          />
        </svg>
      </div>
      <div className="red-info__text">{children}</div>
    </div>
  )
}
